import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/form-requests/userWorkflow/:userWorkflowId/autofills/initialValues']['GET'];

type Input = ThisApi['params'] & ThisApi['query'];
type Output = ThisApi['response'];

const getAutofillInitialValue = async ({
  expressionVariableReferenceId,
  expressionVariableReferenceType,
  questionnaireId,
  referenceId,
  referenceType,
  userWorkflowId,
}: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/form-requests/userWorkflow/{userWorkflowId}/autofills/initialValues', {
    userWorkflowId,
  });
  const data = await noodleApiClient.get(path, {
    params: {
      expressionVariableReferenceId,
      expressionVariableReferenceType,
      questionnaireId,
      referenceId,
      referenceType,
    },
  });
  return data.data;
};

export default getAutofillInitialValue;
